<template>
    <div class="structure-list">
        <app-sub-title text="Estructuras" />
        <div>
            <button
                class="btn btn-primary"
                @click="$router.push({ name: 'loadStructures' })"
            >
                <i class="fa fa-upload"></i> Cargar Estructuras
            </button>
            <button
                :disabled="!thereAreClientId"
                class="btn btn-primary"
                @click="startSaveStructure()"
            >
                <i class="fa fa-building-o"></i> Crear nueva estructura
            </button>
            <!-- <app-form-select-input label="Seleccione el Cliente" :options="clients" @change="loadStructures" v-model="clientId" /> -->
            <app-autocomplete
                v-if="!isClientUser"
                label="Cliente"
                :items="clients"
                v-model="selectedClient"
            />
        </div>
        <div class="filters" v-if="clientId">
            <app-sub-title text="Filtros" />
            <div class="card">
                <div class="card-body">
                    <div class="card-text">
                        <div class="d-flex justify-content-around">
                            <div>
                                <app-form-select-input
                                    label="Tipo"
                                    :options="structureTypes"
                                    v-model="filters.type"
                                />
                            </div>
                            <div>
                                <app-form-text-input
                                    label="Nombre"
                                    v-model="filters.name"
                                />
                            </div>
                            <div
                                class="d-flex justify-content-between align-items-end buttons-cell"
                            >
                                <button
                                    @click="searchStructures"
                                    class="btn btn-primary flex-grow-0 flex-shrink-0"
                                >
                                    <i class="fa fa-filter"></i> Filtrar
                                </button>
                                <button
                                    @click="cancelFilter"
                                    class="btn btn-secondary flex-grow-0 flex-shrink-0"
                                >
                                    <i class="fa fa-times-circle"></i> Reiniciar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <app-table-structures
            v-if="clientId"
            :data="data"
            :on-change-page="onChangePage"
            :show-vehicles="showVehicles"
            :show-people="showPeople"
            :delete-structure="startRemove"
            @sort="onSort"
        />

        <!-- inicio de pop ups -->

        <app-pop-up title="Confirmación" id="structure-remove">
            <div slot="body">
                <h2>¿Esta seguro que desea eliminar esta estructura?</h2>
            </div>
            <div class="buttons" slot="buttons">
                <button
                    class="btn btn-confirm"
                    @click="deleteStructure(selectedStructure)"
                >
                    <i class="fa fa-trash-o" aria-hidden="true"></i> Confirmar
                    Eliminación
                </button>
            </div>
        </app-pop-up>

        <app-pop-up
            title="Formulario de estructura"
            id="structure-form"
            :onClose="cleanForm"
            v-if="!!clientId"
        >
            <div class="body" slot="body">
                <app-structure-form-page
                    :my-client="selectedClient"
                    :onSave="onSave"
                ></app-structure-form-page>
            </div>
            <div slot="buttons">
                <button
                    class="btn btn-confirm"
                    :disabled="inProgress"
                    @click="$bus.$emit('structure-form.save')"
                >
                    Guardar
                </button>
            </div>
        </app-pop-up>

        <!-- fin de pop ups -->
    </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import * as mutations from '@store/commitTypes'
import structuresRepository from '../../../repositories/structures.repository'
import clientsRepository from '../../../repositories/clients.repository'
import StructureFormPage from './StructureFormPage.vue'
import TableStructures from './TableStructures/TableStructures.vue'
// import Autocomplete from '@components/UI/Controls/AutocompleteV2/Autocomplete';

export default {
    components: {
        appStructureFormPage: StructureFormPage,
        appTableStructures: TableStructures,
        // appAutocomplete: Autocomplete
    },
    props: {
        preselectedClientId: {
            default: '',
        },
    },
    data() {
        return {
            page: 1,
            clientId: '',
            thereAreClientId: false,
            structures: [],
            filters: {
                name: '',
                type: '',
            },
            selectedStructure: '',
            isAdminClient: false,
            data: {},
            sort: {
                sortBy: 'name',
                sortDir: 'asc',
            },
            roundConfig: true,
            selectedClient: '',
        }
    },
    watch: {
        clientId() {
            if (this.clientId) {
                this.thereAreClientId = true
            } else {
                this.thereAreClientId = false
            }
        },
        selectedClient(client) {
            this.clientId = client.id
            this.loadStructures()
        },
    },
    computed: {
        ...mapGetters(['clients', 'structureTypes', 'client']),
        isClientUser() {
            return this.user.profile.slug === 'cliente-admin' || 
                   this.user.profile.client_side === true;
        },
    },
    methods: {
        ...mapMutations({
            setSelectedRound: mutations.SET_SELECTED_ROUND,
        }),
        showPeople(structureId) {
            if (this.isAdminClient) {
                this.$router.push({
                    name: 'listPeopleAdminClient',
                    params: { structureId },
                })
            } else {
                this.$router.push({
                    name: 'listPeople',
                    params: { structureId },
                })
            }
        },
        showVehicles(structureId) {
            if (this.isAdminClient) {
                this.$router.push({
                    name: 'listVehiclesAdminClient',
                    params: { structureId },
                })
            } else {
                this.$router.push({
                    name: 'listVehicles',
                    params: { structureId },
                })
            }
        },
        loadStructures() {
            if (!this.clientId) {
                this.structures = []
                return false
            }

            const filters = {
                ...this.filters,
                sortBy: this.sort.sortBy,
                sortDir: this.sort.sortDir,
            }

            const sr = Object.assign({}, structuresRepository)
            sr.getPaginated(this.clientId, this.page, filters)
                .then(data => {
                    this.data = data.data
                    this.structures = data.data
                })
                .catch(error =>
                    toastr.error('Ocurrió un error al cargar las estructuras')
                )
        },
        deleteStructure(structure) {
            const sr = Object.assign({}, structuresRepository)
            sr.deleteStructure(structure.id)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg)
                        this.loadStructures()
                        this.$bus.$emit('structure-remove.close')
                    } else {
                        toastr.error(data.msg)
                    }
                })
                .catch(error => {
                    toastr.error('No se pudo borrar la estructura')
                })
        },
        startRemove(structure) {
            this.selectedStructure = structure
            this.$bus.$emit('structure-remove.open')
        },
        startSaveStructure() {
            this.$bus.$emit('structure-form.open')
        },
        onSave(structure) {
            this.$bus.$emit('structure-form.close')
            this.loadStructures()
        },
        cleanForm() {
            this.$bus.$emit('structure-form.clean')
        },
        onChangePage(page) {
            this.page = page
            this.loadStructures()
        },
        loadClientSelected() {
            !!this.preselectedClientId &&
                (this.clientId = this.preselectedClientId)
            !!this.clientId && this.loadStructures()
        },
        searchStructures() {
            this.page = 1
            this.loadStructures()
        },
        cancelFilter() {
            this.page = 1
            Object.keys(this.filters).map(key => (this.filters[key] = ''))
            this.loadStructures()
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy
            this.sort.sortDir = ctx.sortDir
            this.loadStructures()
        },
    },
    created() {
        this.load('clients')
        this.load('structureTypes')

        this.isAdminClient = !!this.user.profile.client_side
        
        // Si es cliente-admin o client_side, establecer el cliente automáticamente
        if (this.isClientUser && this.client) {
            this.clientId = this.client.id
            this.selectedClient = this.client
            this.thereAreClientId = true
            this.loadStructures()
        }
    },
}
</script>
